import React from 'react';
import PropTypes from 'prop-types';
import 'css/empty-state.css';

var EmptyState = function(props) {
  var icon = props.icon;
  var title = props.title;
  var description = props.description;
  var buttonLabel = props.buttonLabel;
  var buttonIcon = props.buttonIcon || 'add';
  var onAction = props.onAction;

  return (
    <div className="empty-state">
      <div className="empty-state-illustration">
        <div className="empty-state-icon">
          <span className="material-symbols-outlined">{icon}</span>
        </div>
        <div className="empty-state-ripple empty-state-ripple-1" />
        <div className="empty-state-ripple empty-state-ripple-2" />
        <div className="empty-state-ripple empty-state-ripple-3" />
      </div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-description">{description}</p>
      {buttonLabel && onAction && (
        <button
          type="button"
          className="empty-state-action-btn"
          onClick={onAction}
        >
          <span className="material-symbols-outlined">{buttonIcon}</span>
          {buttonLabel}
        </button>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  onAction: PropTypes.func,
};

export default EmptyState;
